import { useEffect } from "react";

/**
 * Sets document title and meta description for SEO (e.g. on dedicated landing/SEO pages).
 */
export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", description);
    }
    return () => {
      document.title = "Sandhurst Interiors - Commercial Office Fit-Out & Refurbishment Specialists";
      if (meta) {
        meta.setAttribute(
          "content",
          "Commercial office fit-out and refurbishment specialists in the South East. Family-run with 30+ years experience. Partitioning, ceilings, flooring, electrical, AC and more."
        );
      }
    };
  }, [title, description]);
}
